const languageToggleAdapter = data =>
	data?.edges.map(({ node }) => ({
		id: node.context.id,
		path: node.path,
		lang: node.context.locale.toUpperCase().substring(0, 2),
	}));

export default languageToggleAdapter;
